import PropTypes from 'prop-types';

// Hooks
import { ADD_LABEL, REMOVE_LABEL, useAlbumContext } from '@/utils/hooks/context/useAlbumContext';

// Components
import Icon from '@/components/base/Icon';
import Label from '@/components/base/Label';
import SelectAlbumTags from '@/components/pages/albums/AlbumFunnelModal/components/SelectAlbumTags';
import useTranslation from 'next-translate/useTranslation';

const AlbumTagsFilter = ({ labelsOptions }) => {
    const { t } = useTranslation('content');
    const { albumInfo, dispatch } = useAlbumContext();

    function addLabel(item) {
        dispatch({
            type: ADD_LABEL,
            payload: item?.value
        });
    }

    function removeLabel(item) {
        dispatch({
            type: REMOVE_LABEL,
            payload: item?.value
        });
    }

    return (
        <div>
            <Label className="flex items-center space-x-2.5 pb-2">
                <Icon icon="labels" className="text-sm text-icoBlue" />
                <span className="text-icoBlack dark:text-white">{t('modal.labels')}</span>
            </Label>
            <SelectAlbumTags
                placeholder={t('modal.select_labels')}
                selectedItems={
                    labelsOptions?.filter((item) =>
                        albumInfo?.criteria?.labels?.includes(item?.value)
                    ) ?? []
                }
                idInput="labels-search"
                options={
                    labelsOptions?.filter(
                        (item) => !albumInfo?.criteria?.labels?.includes(item?.value)
                    ) ?? []
                }
                addItem={addLabel}
                removeItem={removeLabel}
            />
        </div>
    );
};

AlbumTagsFilter.propTypes = {
    labelsOptions: PropTypes.array
};

export default AlbumTagsFilter;
